// extracted by mini-css-extract-plugin
export default {"movieList":"MovieList_movieList__KLHv+","movieListCard":"MovieList_movieListCard__t3yqH","deleteButton":"MovieList_deleteButton__fpwjl"};